import { css } from 'styled-components';
import { TextOverflowEllipsis } from 'styles/utils/text.styles';

export const labelAndIconInGridStyles = css`
  display: grid;
  grid-template-columns: 1fr min-content;
  justify-items: start;
  align-items: center;
`;

export const labelNoWrapStyles = css`
  ${TextOverflowEllipsis};
  max-width: 100%;
`;
